import styles from "./styles.module.scss";
import cn from "classnames";

export const JobResourcePage = ({ backgroundImage, eventLabel, title, type, other, content, className }) => {
  return (
    <section className={cn(styles.JobResourcePage, className)}>
      <div className={styles.hero} style={{ backgroundImage: `url(${backgroundImage?.url})` }}>
        <div className={styles.heroContent}>
          <div className={styles.event}>{eventLabel}</div>
          <h1 className={styles.title}>{title}</h1>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.section}>
            <div className={styles.label}>Type</div>
            <div className={styles.value}>{type}</div>
          </div>
          <div className={styles.section}>
            <div className={styles.label}>Other</div>
            <div className={styles.value}>{other}</div>
          </div>
        </div>
        <div className={styles.description} dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </section>
  );
};

export default JobResourcePage;
